







































/* General */
import Vue from 'vue'
import RegistrationLayout from '@/layouts/registration-layout.vue'
import MainContainer from '@/layouts/main-container.vue'

/* Mixins */

/* Components */
import StandardEmailInput from '@/components/global/inputs/standard-email-input.vue'

/* Helpers */
import RouteAssistant from '@/helpers/route-assistant'

/* Data types */
import { IItemForSelection } from '@/api/types/response.types'

/* API */
import AccountMembershipsAPI from '@/api/modules/account-memberships.api'

export default Vue.extend({
  name: 'AccountRegistrationAddMembers',

  metaInfo(): any {
    return {
      title: 'Invite team members',
    }
  },

  components: {
    RegistrationLayout,
    MainContainer,
  },

  data() {
    return {
      RouteAssistant,
      isSubmitting: false,
      invalidEmailRows: [] as number[],
      StandardEmailInput,
      listEmailAddresses: ['', '', ''],
      steps: [
        { id: 1, name: 'You' },
        { id: 2, name: 'Company' },
        { id: 3, name: 'Team' },
      ] as IItemForSelection[],
      currentStepID: 3,
    }
  },

  computed: {
    enabledNewInvites(): boolean {
      return this.listEmailAddresses.length < 10
    },
    disableSubmit(): boolean {
      return this.invalidEmailRows.length > 0
    },
    email(): string {
      return this.$route.query.email
    },
  },

  methods: {
    addRow(): void {
      /* Stub new row with blank email but carryover other columns */
      if (this.enabledNewInvites) {
        this.listEmailAddresses.push('')
      }
    },
    addInvalidEmailIndex(index: number) {
      // Add the index from the invalid list...
      if (this.invalidEmailRows.includes(index)) {
        return
      }
      this.invalidEmailRows.push(index)
    },
    addValidEmailIndex(index: number) {
      // Remove the index from the invalid list...
      if (this.invalidEmailRows.includes(index)) {
        this.invalidEmailRows = this.invalidEmailRows.filter(e => e !== index)
      }
    },
    async submitForm() {
      const noEmails =
        this.listEmailAddresses.filter(e => e !== '').length === 0

      if (noEmails) {
        RouteAssistant.goToDashboard(this.$router, this.$route.params.accountId)
        return
      }

      this.isSubmitting = true
      try {
        const response = await AccountMembershipsAPI.post_InviteCoworkers(
          this.listEmailAddresses,
        )
        /* If no successful emails, response does not emit a message. Just go to dashboard. */
        if (response.message) {
          this.$messaging.showSuccess(response.message)
        }
        RouteAssistant.goToDashboard(this.$router, this.$route.params.accountId)
      } catch (error) {
        this.$error.emit(error, true)
      }

      this.isSubmitting = false
    },
  },
})
